export default {
  path: 'Marketing',
  component: () => import('@/views/AppMain/index'),
  name: 'Marketing',
  hidden: false,
  alwaysShow: true,
  meta: {
    title: '营销管理',
    keepAlive: false,
    icon: '1037',
    activeIcon: '1036'
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    // {
    //   hidden: false,
    //   path: "RechargedProducts",
    //   component: () => import('@/views/AppMain/index'),
    //   name: "RechargedProducts",
    //   alwaysShow: true,
    //   meta: {
    //     title: "充值产品",
    //     keepAlive: false,
    //   },
    //   children:[
    //     {
    //       hidden: false,
    //       path: "RechargeSettings",
    //       component: () => import("@/views/HeadOfficeManagement/Marketing/RechargeSettings"),
    //       name: "RechargeSettings",
    //       meta: {
    //         title: "充值设置",
    //         keepAlive: true,
    //       },
    //     },
    //     {
    //       hidden: false,
    //       path: "RechargeRecord",
    //       component: () => import("@/views/HeadOfficeManagement/Marketing/RechargeRecord"),
    //       name: "RechargeRecord",
    //       meta: {
    //         title: "充值记录",
    //         keepAlive: true,
    //       },
    //     },
    //   ]
    // },
    // {
    //     hidden: false,
    //     path: "RechargeGiftActivity",
    //     component: () => import("@/views/HeadOfficeManagement/Marketing/RechargeGiftActivity"),
    //     name: "RechargeGiftActivity",
    //     meta: {
    //       title: "充值赠送活动",
    //       keepAlive: true,
    //     },
    //   },
    {
      hidden: false,
      path: 'Coupon',
      component: () => import('@/views/HeadOfficeManagement/Marketing/Coupon'),
      name: 'Coupon',
      meta: {
        title: '优惠券',
        keepAlive: true
      }
    },
    //   {
    //     hidden: false,
    //     path: "FlashSale",
    //     component: () => import("@/views/HeadOfficeManagement/Marketing/FlashSale"),
    //     name: "FlashSale",
    //     meta: {
    //       title: "限时特价",
    //       keepAlive: true,
    //     },
    //   },
    //   {
    //     hidden: false,
    //     path: "PointsActivity",
    //     component: () => import("@/views/HeadOfficeManagement/Marketing/PointsActivity"),
    //     name: "PointsActivity",
    //     meta: {
    //       title: "积分活动",
    //       keepAlive: true,
    //     },
    //   },
    {
      hidden: false,
      path: 'FullDiscountActivity',
      component: () => import('@/views/HeadOfficeManagement/Marketing/FullDiscountActivity'),
      name: 'FullDiscountActivity',
      meta: {
        title: '满减活动',
        keepAlive: true
      }
    }, {
      hidden: true,
      path: 'FullDiscountActivityAdd',
      component: () => import('@/views/HeadOfficeManagement/Marketing/FullDiscountActivityAdd'),
      name: 'FullDiscountActivityAdd',
      meta: {
        title: '新增/编辑满减活动',
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/Marketing/FullDiscountActivity'
      }
    },
    {
      hidden: false,
      path: 'giveCouponActivity',
      component: () => import('@/views/HeadOfficeManagement/Marketing/giveCouponActivity'),
      name: 'giveCouponActivity',
      meta: {
        title: '送券活动',
        keepAlive: true
      }
    }, {
      hidden: true,
      path: 'giveCouponActivityAdd',
      component: () => import('@/views/HeadOfficeManagement/Marketing/giveCouponActivityAdd'),
      name: 'giveCouponActivityAdd',
      meta: {
        title: '新增/编辑送券活动',
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/Marketing/giveCouponActivity'
      }
    },
    {
      hidden: true,
      path: 'RechargeGiftActivityAdd',
      component: () => import('@/views/HeadOfficeManagement/Marketing/RechargeGiftActivityAdd'),
      name: 'RechargeGiftActivityAdd',
      meta: {
        title: '新增/编辑充值赠送活动',
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/Marketing/RechargeGiftActivity'
      }
    },
    {
      hidden: true,
      path: 'CouponAdd',
      component: () => import('@/views/HeadOfficeManagement/Marketing/CouponAdd'),
      name: 'CouponAdd',
      meta: {
        title: '新增/编辑优惠券',
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/Marketing/Coupon'
      }
    },
    {
      hidden: true,
      path: 'FlashSaleAdd',
      component: () => import('@/views/HeadOfficeManagement/Marketing/FlashSaleAdd'),
      name: 'FlashSaleAdd',
      meta: {
        title: '新增/编辑限时特价',
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/Marketing/FlashSale'
      }
    },
    {
      hidden: true,
      path: 'PointsActivityAdd',
      component: () => import('@/views/HeadOfficeManagement/Marketing/PointsActivityAdd'),
      name: 'PointsActivityAdd',
      meta: {
        title: '新增/编辑积分活动',
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/Marketing/PointsActivity'
      }
    },
    {
      hidden: false,
      path: 'PostageManagement',
      component: () => import('@/views/HeadOfficeManagement/Marketing/PostageManagement'),
      name: 'PostageManagement',
      meta: {
        title: '邮费管理',
        keepAlive: true
      }
    }
    // {
    //   hidden: false,
    //   path: "CommodityPreSale",
    //   component: () => import('@/views/AppMain/index'),
    //   name: "CommodityPreSale",
    //   alwaysShow: true,
    //   meta: {
    //     title: "预售活动",
    //     keepAlive: true,
    //   },
    //   children:[{
    //     hidden: false,
    //     path: "PreSale",
    //     component: () => import("@/views/HeadOfficeManagement/Marketing/PreSale"),
    //     name: "PreSale",
    //     meta: {
    //       title: "活动配置",
    //       keepAlive: true,
    //       activeMenu: '/HeadOfficeManagement/Marketing/CommodityPreSale/PreSale'
    //     }
    //   },
    //   {
    //     hidden: true,
    //     path: "PreSaleAdd",
    //     component: () => import("@/views/HeadOfficeManagement/Marketing/PreSaleAdd"),
    //     name: "PreSaleAdd",
    //     meta: {
    //       title: "预售商品添加/编辑",
    //       keepAlive: false,
    //       activeMenu: '/HeadOfficeManagement/Marketing/CommodityPreSale/PreSale'
    //     }
    //   },{
    //     hidden: false,
    //     path: "PreSaleStock",
    //     component: () => import("@/views/HeadOfficeManagement/Marketing/PreSaleStock"),
    //     name: "PreSaleStock",
    //     meta: {
    //       title: "预售库存",
    //       keepAlive: true,
    //       activeMenu: '/HeadOfficeManagement/Marketing/CommodityPreSale/PreSale'
    //     }
    //   },
    // ]
    // }
  ]
}
